import React, { useState, useEffect, useMemo } from "react";

import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { fetchContractTypes } from "../../redux/actions/ContractTypeActions";
import { displayDateFormart, isValidArr } from "../../utility/utils";
import EnhancedTable from "../table/Table";
import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import ContractTypeForm from "./ContractTypeForm";
import Loader from "../../components/loader/Loader";
import { ContractTypeModel } from "../../models/ContractTypeModel";

export type Mode = "add" | "edit";

type iData = {
  id: number;
  name: string;
  description: string;
  createdDate: string;
  // status: string;
};

const ContractTypePage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<ContractTypeModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allContractTypes = useAppSelector(
    (state) => state.contractType.all_ContractTypes
  );

  const isContractTypesFetching = useAppSelector(
    (state) => state.contractType.isContractTypesFetching
  );

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: "Name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: "Description",
      },
      {
        id: "createdDate",
        numeric: false,
        disablePadding: false,
        label: "Created Date",
        width: 150,
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  //To fetch all contract types
  useEffect(() => {
    dispatch(fetchContractTypes());
  }, [dispatch]);

  // To prepare the root data
  useEffect(() => {
    setRootData(() =>
      allContractTypes.map((contractType) => ({
        id: contractType.contractTypeId,
        name: contractType.name,
        description: contractType.description,
        createdDate: displayDateFormart(contractType.createdDate),
        // status: contractType.isActive ? "Active" : "Inactive",
      }))
    );
  }, [allContractTypes]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const editRec = allContractTypes.find((rec) => rec.contractTypeId === id);
    setMode("edit");
    setEditData(editRec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allContractTypes) && isContractTypesFetching ? (
        <Loader />
      ) : null}
      <PageTitle
        title="Contract Types"
        btnText="Add Contract Type"
        onClick={createHandler}
      />
      <PageSearch
        placeholder="Search Contract Types"
        searchHandler={searchHandler}
      />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={
            mode === "add" ? "Create Contract Type" : "Edit Contract Type"
          }
          handleModalClose={handleModalClose}
        >
          <ContractTypeForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default ContractTypePage;
